<template>
  <a
    :href="`https://hd.weibo.com/senior/view/${item.id}`"
    target="_blank"
    :class="[`${type}-type`, `${size}-size`]"
    class="senior-case-item-wrapper font-color-body"
  >
    <div class="banner">
      <img v-lazy="item.banner" />
      <slot name="after-banner-inner"></slot>
    </div>
    <slot>
      <div class="main-content" :style="{ borderColor }">
        <h3 class="title">{{ item.activity_name }}</h3>
        <div class="others">
          <div v-if="item.brand" class="brand-wrapper">
            <img v-if="type !== 'list'" :src="item.thumbnail" />
            <span class="brand-name">
              {{ item.brand.name }}
            </span>
          </div>
        </div>
        <slot name="after-main-inner"></slot>
      </div>
    </slot>
    <template v-if="type === 'card'">
      <div
        v-if="!noFileTypes && item.file_type && item.file_type.length > 0"
        class="file-types"
      >
        <b>文件</b>
        <span>{{ item.file_type | joinFileType }}</span>
      </div>
      <div
        v-if="!noBadge"
        class="badge"
        :class="{
          'is-award': item.isaward - 0 === 1,
          'is-new': isNew,
          'is-top': item.istop - 0 === 1
        }"
      ></div>
    </template>
    <slot name="after"></slot>
  </a>
</template>

<script>
import { date } from '@/utils'
import dayjs from 'dayjs'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    type: {
      validator(value) {
        return ['card', 'list', 'rank', 'custom'].includes(value)
      },
      default: 'card'
    },
    size: {
      type: String,
      default: 'normal'
    },
    noFileTypes: Boolean,
    noBadge: Boolean,
    borderColor: { type: String, default: '' }
  },
  computed: {
    isNew() {
      const { start_time } = this.item
      const start = dayjs(start_time)
      return !date.isRoughAgo(start, 180, 'day')
    }
  }
}
</script>

<style lang="scss" scoped>
.senior-case-item-wrapper {
  border-radius: 8px;
  display: block;
  overflow: hidden;
  margin-bottom: 30px;
  position: relative;
  background-color: #ffffff;
  .banner {
    position: relative;
    overflow: hidden;
    transition: transform 0.2s;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      float: left;
      object-fit: cover;
    }
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.15);
      z-index: 10;
      display: none;
    }
    &:after {
      content: '';
      display: block;
      padding-bottom: 50%;
      height: 0;
    }
  }
  .badge {
    position: absolute;
    width: 26px;
    height: 38px;
    top: 0;
    left: 16px;
    background: no-repeat center/100% 100%;
    z-index: 10;
    &.is-new {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMjYgMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5pawPC90aXRsZT4KICAgIDxnIGlkPSLorr7orqHnqL8iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLokKXplIDmoYjkvost5b+r6YCf6YCJ5oup6KGM5Lia6I+c5Y2VIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQzLjAwMDAwMCwgLTEwMzYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLokKXplIDmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDMzNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSLmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA3MDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IuaWsCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMDAwMDAwLCAwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0i6Lev5b6EIiBmaWxsPSIjMzM1MkZFIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iMCAtNC4wODcwMDg1MWUtMTUgMCAzOCAxMi45OTk5NzU1IDMwLjAxMzQ2NjYgMjYgMzggMjYgMCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICA8dGV4dCBmb250LWZhbWlseT0iUGluZ0ZhbmdTQy1NZWRpdW0sIFBpbmdGYW5nIFNDIiBmb250LXNpemU9IjE0IiBmb250LXdlaWdodD0iNDAwIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI2IiB5PSIyMCI+5pawPC90c3Bhbj4KICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+');
    }
    &.is-award {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMjYgMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+5aWWPC90aXRsZT4KICAgIDxnIGlkPSLorr7orqHnqL8iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLokKXplIDmoYjkvost5b+r6YCf6YCJ5oup6KGM5Lia6I+c5Y2VIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTQ2LjAwMDAwMCwgLTEwMzYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLokKXplIDmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDMzNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSLmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwMy4wMDAwMDAsIDcwMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i5aWWIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSLot6/lvoQiIGZpbGw9IiNCQjlEN0QiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIwIC00LjA4NzAwODUxZS0xNSAwIDM4IDEyLjk5OTk3NTUgMzAuMDEzNDY2NiAyNiAzOCAyNiAwIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0IGZvbnQtZmFtaWx5PSJQaW5nRmFuZ1NDLU1lZGl1bSwgUGluZ0ZhbmcgU0MiIGZvbnQtc2l6ZT0iMTQiIGZvbnQtd2VpZ2h0PSI0MDAiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjYiIHk9IjIwIj7lpZY8L3RzcGFuPgogICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=');
    }
    &.is-top {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjdweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMjcgMzgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+6aG2PC90aXRsZT4KICAgIDxnIGlkPSLorr7orqHnqL8iIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLokKXplIDmoYjkvost5b+r6YCf6YCJ5oup6KGM5Lia6I+c5Y2VIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTQ5LjAwMDAwMCwgLTEwMzYuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLokKXplIDmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDMzNi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSLmoYjkvosiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgwNi4wMDAwMDAsIDcwMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0i6aG2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNi4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSLot6/lvoQiIGZpbGw9IiNGODY1M0YiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIwIC00LjA4NzAwODUxZS0xNSAwIDM4IDEzLjQ5OTk3NDUgMzAuMDEzNDY2NiAyNyAzOCAyNyAwIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0IGZvbnQtZmFtaWx5PSJQaW5nRmFuZ1NDLU1lZGl1bSwgUGluZ0ZhbmcgU0MiIGZvbnQtc2l6ZT0iMTQiIGZvbnQtd2VpZ2h0PSI0MDAiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjYuMjMwNzY5MjMiIHk9IjIwIj7pobY8L3RzcGFuPgogICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=');
    }
  }
  .others {
    position: relative;
    overflow: hidden;
  }
  .main-content {
    position: relative;
    overflow: hidden;
    transition: transform 0.2s;
    .title {
      font-weight: bold;
      margin: 0 0 10px;
      transition: all 0.2s;
    }
  }
  &.card-type,
  &.rank-type {
    .main-content {
      border: 1px solid #efeff3;
      border-top: none;
      .put-time {
        font-size: 13px;
        color: #727272;
      }
      .brand-wrapper {
        float: left;
        img {
          width: 36px;
          height: 36px;
          box-sizing: border-box;
          float: left;
          border-radius: 50%;
          border: 1px solid #f4f5f7;
          vertical-align: middle;
          margin-right: 10px;
        }
        .brand-name {
          font-size: 14px;
          vertical-align: middle;
          line-height: 36px;
        }
      }
    }
  }
  &.card-type {
    .main-content {
      padding: 16px 20px 32px;
      border-radius: 0 0 8px 8px;
      .title {
        font-size: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .put-time {
        float: right;
        font-size: 13px;
        color: #727272;
        line-height: 36px;
      }
      .brand-wrapper {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      .banner {
        transform: translateY(-16px);
        &:before {
          display: block;
        }
      }
      .main-content {
        border-color: transparent;
        transform: translateY(-16px);
      }
    }
    &.small-size {
      margin-bottom: 24px;
      border-radius: 3px;
      .main-content {
        padding: 8px 12px 20px;
        .title {
          font-size: 14px;
        }
        .put-time,
        .brand-name {
          font-size: 12px;
          line-height: 20px;
        }
        .brand-wrapper {
          line-height: 20px;
          img {
            width: 20px;
            height: 20px;
          }
        }
      }
      &:hover {
        .banner,
        .main-content {
          transform: translateY(-8px);
        }
      }
    }
  }
  &.rank-type {
    .main-content {
      padding: 16px 88px 29px 16px;
      .title {
        display: none;
      }
      .brand-wrapper {
        img {
          width: 32px;
          height: 32px;
        }
      }
      .brand-name {
        display: inline-block;
        position: relative;
        height: 36px;
        line-height: 36px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 110px;
        top: -2px;
        .put-time {
          display: block;
          white-space: nowrap;
          overflow: visible;
        }
      }
      .others {
        & > .put-time {
          display: none;
        }
      }
    }
    &:first-child {
      .banner {
        border-radius: inherit;
      }
      .main-content {
        .title {
          display: block;
        }
      }
      &:hover {
        .main-content {
          .title {
            transform: translateY(-12px);
          }
        }
      }
    }
    &:hover {
      .banner {
        transform: translateY(-12px);
        &:before {
          display: block;
        }
      }
    }
  }
  &.list-type {
    .banner {
      float: left;
      width: 300px;
      border-radius: 8px;
      margin-right: 16px;
    }
    .main-content {
      padding: 12px 0;
      .title {
        font-size: 24px;
        margin-bottom: 16px;
      }
      .brand-wrapper {
        &:after {
          content: '\7C';
          margin: 0 5px;
        }
      }
      .put-time,
      .brand-wrapper {
        float: left;
        font-size: 14px;
      }
    }
  }
  .file-types {
    position: absolute;
    top: 14px;
    right: 16px;
    font-size: 13px;
    color: #ffffff;
    overflow: hidden;
    border-radius: 3px;
    b,
    span {
      float: left;
      height: 22px;
      line-height: 22px;
      padding: 0 8px;
    }
    b {
      background-color: #ffffff;
      color: #363636;
    }
    span {
      background-color: rgba(54, 54, 54, 0.45);
    }
  }
}
</style>
